/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { IShopAddon } from "api/types/shop_quote/addon";
/// URLS ///
import { url_prefix } from "settings";
import { shop_addon_url } from "../../endpoints";

export const createShopAddon = (addon: IShopAddon) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    dispatch({
      type: ActionType.SHOP_QUOTE_UPDATING
    });

    const { user } = getState().authentication;

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${shop_addon_url}/`;

    try {
      const { data } = await axios.post(url, addon, config);
      dispatch({
        type: ActionType.UPDATE_SHOP_QUOTE,
        payload: data
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_QUOTE_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
